let mobileMenuLoaded = false

class MobileMenu extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (mobileMenuLoaded) return

    let view = 'mobile-menu'
    if (window.theme.templateSuffix === 'beauty' || window.theme.isBeauty) {
      view = 'beauty-mobile-menu'
    }

    window.BAO.sectionRenderer
      .fetch(
        this.dataset.sectionId,
        `${window.Shopify.routes.root}?view=${view}`,
      )
      .then((res) => {
        mobileMenuLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(
          res[this.dataset.sectionId],
        )
        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML
      })
      .catch(() => {})
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.trigger?.exists) {
      this.handleTrigger = this.handleTrigger.bind(this)

      this.els.trigger.elements.forEach((triggerEl) => {
        this.listeners.add(triggerEl, 'click', this.handleTrigger)
      })
    }

    if (
      this.externalEls?.trigger?.exists &&
      window.theme.templateSuffix === 'beauty'
    ) {
      this.handleExternalTrigger = this.handleExternalTrigger.bind(this)

      this.externalEls.trigger.elements.forEach((triggerEl) => {
        this.listeners.add(triggerEl, 'click', this.handleExternalTrigger)
      })
    }
  }

  handleTrigger (event) {
    const clickedTriggerEl = event.target.closest(this.els?.trigger?.selector)

    this.els.trigger.elements.forEach((triggerEl) => {
      triggerEl.setAttribute('aria-pressed', triggerEl === clickedTriggerEl)
    })

    this.els.panel.elements.forEach((panelEl) => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.navigation !== clickedTriggerEl.dataset.navigation,
      )
    })
  }

  handleExternalTrigger (event) {
    const clickedTriggerEl = event.target.closest(
      this.externalEls?.trigger?.selector,
    )

    this.externalEls.trigger.elements.forEach((triggerEl) => {
      triggerEl.setAttribute('aria-pressed', triggerEl === clickedTriggerEl)
    })

    this.externalEls.panel.elements.forEach((panelEl) => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.navigation !== clickedTriggerEl.dataset.navigation,
      )
    })
  }
}

if (!customElements.get('mobile-menu')) {
  customElements.define('mobile-menu', MobileMenu)
}
